<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/iqc/inspection/bill/detail/page" getKey="rows" :columns="columns">
      <template #conditions>
        <div>
          <div>{{ $t('jianyandanhao') }}: {{ iqcInspectionNo }}</div>
          <br />
        </div>
      </template>

      <template #jianyanjieguo="scope">
        <div v-if="scope.row.result == null"></div>
        <div v-else>{{ scope.row.result === 1 ? $t('hege') : $t('buhege') }}</div>
      </template>
      <template #jianyanbiaoshi="scope">
        <div>{{ scope.row.inspectionFlag === 1 ? $t('dingxing') : $t('dingliang') }}</div>
      </template>
      <template #shifoubijian="scope">
        <div v-if="scope.row.inspectionStandardDetail">{{ scope.row.inspectionStandardDetail.necessity === 1 ? $t('shi') : $t('fou') }}</div>
      </template>
      <template #chouyangguocheng="scope">
        <span v-if="scope.row.samplingProcedure">{{ scope.row.samplingProcedure.code }}/{{ scope.row.samplingProcedure.desc }}</span>
      </template>
      <template #celiangzhi="scope">
        <span v-if="scope.row.inspectionFlag === 2">
          <el-popover placement="bottom" width="105" popper-class="my-el-popover" trigger="click">
            <div v-html="toStr(scope.row.measureJson)"></div>
            <el-button slot="reference" type="text"> {{ scope.row.measureJson == null || scope.row.measureJson == '' ? '' : $t('chakan') }}</el-button>
          </el-popover>
        </span>
        <span v-else>
          {{ scope.row.measureJson == null ? '' : scope.row.measureJson + '' }}
        </span>
      </template>
      <template #tupian="scope">
        <yi_upload :readOnly="true" :ids.sync="scope.row.uploadFiles" :limit="5"> </yi_upload>
      </template>
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_cast_management_soup_record_iqc_inspection_detail',
  props: {
    iqcInspectionId: {
      type: Number,
      required: true
    },
    iqcInspectionNo: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      conditions: {
        iqcInspectionId: this.iqcInspectionId
      },
      columns: [
        {
          label: 'jianyanjieguo',
          prop: 'result',
          type: 'slot'
        },
        {
          label: 'gongxu',
          prop: 'inspectionStandardDetail.procedure'
        },
        {
          label: 'jianyanleibie',
          prop: 'inspectionStandardDetail.category'
        },
        {
          label: 'jianyanxiangmu',
          prop: 'inspectionStandardDetail.item'
        },
        {
          label: 'jianyangongju',
          prop: 'inspectionStandardDetail.tool'
        },
        {
          label: 'jianyanbiaoshi',
          prop: 'inspectionFlag',
          type: 'slot'
        },
        {
          label: 'jianyanfangshi',
          prop: 'inspectionMethod.name'
        },
        {
          label: 'shifoubijian',
          prop: 'inspectionStandardDetail.necessity',
          type: 'slot'
        },
        {
          label: 'jianyanyiju',
          prop: 'inspectionStandardDetail.basis'
        },
        {
          label: 'quexiandengji',
          prop: 'inspectionStandardDetail.defectLevel'
        },
        {
          label: 'chouyangguocheng',
          prop: 'samplingProcedure.desc',
          type: 'slot'
        },
        {
          label: 'guigexiaxian',
          prop: 'inspectionStandardDetail.specMin'
        },
        {
          label: 'guigeshangxian',
          prop: 'inspectionStandardDetail.specMax'
        },
        {
          label: 'jiliangdanwei',
          prop: 'inspectionStandardDetail.unit',
          type: 'dictionary',
          key: 'UNIT_CONVERSION_TYPE'
        },
        {
          label: 'celiangzhi',
          prop:'measureJson',
          type: 'slot'
        },
        {
          label: 'tupian',
          prop: 'uploadFiles',
          type: 'slot'
        },
        {
          label: 'beizhu',
          prop: 'remark'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = this.utils.copy(this.conditions);
      this.yt.get(1);
    }, 300);
  },
  methods: {
    // 测量值转字符串
    toStr(array) {
      if (!array) {
        return '';
      }
      let str = '';
      for (let i = 0; i < array.length; i++) {
        const a = array[i];
        const s = this.$t('yangben') + `${i + 1}: ${a}`;
        if (i !== array.length - 1) {
          str += s + '<br />';
        } else {
          str += s;
        }
      }
      return str;
    },
  }
};
</script>
